// extracted by mini-css-extract-plugin
module.exports = {"inputcontainer":"TextInput_inputcontainer__3NYbq","inputlabel":"TextInput_inputlabel__239xY"};